import { Button } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { Upload } from '@factorialco/f0-react/icons/app'
import { LOCAL_STORAGE_KEYS } from 'config/Vars'

import getMultiFilters from 'modules/core/components/MultiFilters/hooks/utils/getMultiFilters'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { isStatusWithoutConflict } from 'modules/shift_management/components/ShiftManagement/Content/filters/customFilters'
import { useEnabledFeatures } from 'modules/shift_management/hooks/useEnabledFeatures'
import { useSchedule } from 'modules/shift_management/hooks/useSchedule'
import { useUI } from 'modules/shift_management/hooks/useUI'

interface Props {
  onClick: (toggleModal: boolean) => void
}

const PublishButton = ({ onClick }: Props) => {
  const [{ view, conflictsCount, hasDrafts, hasDraftsWithoutConflict }] = useSchedule()
  const [{ isRefreshingStats }] = useUI()
  const [{ hasFeatureFlag }] = useEnabledFeatures()
  const newEntryFlowEnabled = hasFeatureFlag('dev_shift_management_autoscheduler_entry_flow')

  const { filters } = getMultiFilters(LOCAL_STORAGE_KEYS.shiftEmployees)
  const filterByWithoutConflict = isStatusWithoutConflict(filters)

  let disableButton: boolean
  if (filterByWithoutConflict) {
    disableButton = !hasDraftsWithoutConflict || isRefreshingStats
  } else {
    disableButton = conflictsCount !== 0 || !hasDrafts || isRefreshingStats
  }

  const onClickButton = () => {
    track(trackingEvents.shiftManagement.publishShiftManagementStart, {
      view: view.viewType,
      view_type_by: view.groupType,
      number_of_filters: filters.length,
    })
    onClick(true)
  }

  return (
    <>
      {newEntryFlowEnabled ? (
        <F0Button
          label={i18n.t('shift_management.actions.publish_short')}
          onClick={() => onClickButton()}
          disabled={disableButton}
          icon={Upload}
        >
          {i18n.t('shift_management.actions.publish_short')}
        </F0Button>
      ) : (
        <Button
          disabled={disableButton}
          onClick={() => onClickButton()}
          type="primary"
          iconName="upload"
        >
          {i18n.t('shift_management.actions.publish_short')}
        </Button>
      )}
    </>
  )
}

export default PublishButton
